import React, {useState} from 'react';
import BaseComponent, {AjaxParam} from '@components/base/BaseComponent/BaseComponent';
import HeaderFeatures from "./HeaderFeatures/HeaderFeatures";
import Questions from './Questions.jsx';
import SuperPartnersResultVO from '../../valueObjects/SuperPartnersResultVO';

import styles from "./PageSuperPartners.scss";
import {createRoot} from "react-dom/client";
import {ContextServicePriceProvider} from "@contexts/ContextServicePriceProvider";
import Header from "@components/base/Header/Header";
import CommonPageHeaderData from "@components/base/Header/data/CommonPageHeaderData";
import {ContextCartProvider} from "@contexts/ContextCartProvider";

import '../../common/scss/blueprint-css/_blueprint.scss';
import Footer from "@components/base/Footer/Footer";


class PageSuperPartners extends BaseComponent {

	partners = new SuperPartnersResultVO();
	filtered = false;

	componentDidMount() {
		super.componentDidMount();
	}

	filterPartners = (actionData) => {
		const ap = new AjaxParam();
		ap.callbackSuccess = ({componentData}) => {
			this.filtered = true;
			this.partners = new SuperPartnersResultVO(componentData);
			this.setState(this.state);
		}
		this.ajaxCall('ActionFilterPartners', actionData, ap);
	}

	goToPartnerPage = (e) => {
		e.preventDefault();

		const epartnerId = e.target.getAttribute('id');
		const epartnerUrl = e.target.getAttribute('href');
		const actionData = [
			epartnerId
		];

		const ap = new AjaxParam();
		ap.callbackSuccess = ({componentData}) => {
			window.open(
			  epartnerUrl,
			  '_blank'
			);
		}
		this.ajaxCall('ActionAddVisitToPartner', actionData, ap);
	}

	render() {
		const {
			header,
			questions,
			questionsObj
		} = this.props.data.componentData;


		return (
		  <div>
			  <ContextCartProvider>
				  <ContextServicePriceProvider>
					  <Header data={CommonPageHeaderData}/>
				  </ContextServicePriceProvider>
			  </ContextCartProvider>

			  <header className={styles.header}>
				  <div className={styles.header_img}>
					  <div className={styles.innerHeader}>
						  <h1>Открийте надежден партньор за <br/> вашия интернет проект</h1>

						  <HeaderFeatures/>
					  </div>
				  </div>
			  </header>

			  <section role="main">
				  <section className={styles.mainContainer}>
					  <p>
						  Ако не знаете към кого да се обърнете, за да изработите сайта си, можете да се доверите на
						  нашия дългогодишен опит. Поради спецификата на нашата работа, имаме задълбочен поглед върху
						  голяма част от професионалистите в страната.
					  </p>
					  <p>
						  Специалистите и фирмите, които Ви препоръчаме, са преминали през няколко етапа за оценка.
						  Вярваме, че с тази препоръка ще Ви помогнем да откриете надежден партньор в изработката и
						  развитието на бъдещите Ви онлайн проекти.
					  </p>
					  <p>
						  Отговорете на въпросите по-долу, за да откриете най-подходящия изпълнител на Вашия проект!
					  </p>

					  <Questions
						questions={questions}
						questionsObj={questionsObj}
						onSubmitCallBack={this.filterPartners}
					  />
				  </section>

				  <p className={styles.mt20}>
					  Ако сте уеб специалист/фирма и предлагате най-добрите услуги в своята област, <br/>
					  <a href={'/web-hosting-page-contact.php'} target={'_blank'}>свържете с нас</a> за да станете наш
					  препоръчан партньор!
				  </p>

				  {
					  this.filtered && (this.partners.bullseye.length > 0) ?
						<section className={styles.partnersContainer}>
							{
								(this.partners.bullseye.length > 0) ?
								  this.partners.bullseye.map((val, key) =>
									<div className={styles.partnerRow} key={key}>
										<div>
											<a href={'//' + val.website}
											   target={'_blank'}
											   rel={'nofollow'}
											   id={val.partnerId}
											   onClick={this.goToPartnerPage}>
												{val.companyName}
											</a>
										</div>
										<div>{val.description}</div>
										<div>
											{val.city}
										</div>
									</div>
								  ) : ''
							}
						</section> : null
				  }

				  {
					  this.filtered && (this.partners.other.length > 0) ?
						<>
							<div className={styles.partnersMatchContainer}>
								<div>
									{
										this.partners.withoutMatch === true ?
										  <>Не откриваме партньори, които отговарят на посочените
											  критерии. <br/> Вижте списъка с препоръчани от нас партньори.</>
										  :
										  (this.partners.bullseye.length <= 0) ?
											<>Не откриваме партньори, които отговарят на всички
												критерии. <br/> Вижте списъка с партньори, които отговарят
												на {((this.partners.other[0].countQuestions === 1) ? 'един критерий.' : this.partners.other[0].countQuestions + ' или по-малко критерии.')}</>
											:
											'Партньори, които отговарят на ' + ((this.partners.other[0].countQuestions == 5) ? 5 : 4) + ' критерии:'

									}
								</div>
								{/*
									<div>
										Електронен магазин, Уеб дизайн, Електротехника
									</div>
									*/}
							</div>

							<section className={styles.partnersContainer}>
								{
									(this.partners.other.length > 0) ?
									  this.partners.other.map((val, key) =>
										<div className={styles.partnerRow} key={key}>
											<div>
												<a href={'//' + val.website}
												   target={'_blank'}
												   rel={'nofollow'}
												   id={val.partnerId}
												   onClick={this.goToPartnerPage}>
													{val.companyName}
												</a>
											</div>
											<div>
												{val.description} <br/><br/>
												{
													this.partners.arrOtherAnswers[val.partnerId].map((oaVal, oaKey, row) =>
													  <span key={oaKey}>
																	{oaVal}{(oaKey + 1) === row.length ? '' : ","}&nbsp;
																</span>
													)
												}
											</div>
											<div>
												{val.city}
											</div>
										</div>
									  ) : ''
								}
							</section>
						</> : null
				  }
			  </section>

			  <Footer color={'color-brand-orange-400'}/>
		  </div>
		)
	}
}

const container = document.getElementById(SHVO.pageAppId);
const root = createRoot(container);
root.render(<PageSuperPartners data={SHVO.pageState}/>);
